<ng-template [ngIf]="element.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Cognome e Nome'" [valueInput]="element.legale?.legale.nominativo"></div>
</ng-template>
<ng-template [ngIf]="element.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Ragione sociale'" [valueInput]="element.legale?.legale.nominativo"></div>
</ng-template>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
[labelInput]="'Tipo Legale'" [valueInput]="element.legale?.categoriaLegaleIncaricato.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
[labelInput]="'Parcella'" [valueInput]="element.numeroParcella"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'importo'"
[labelInput]="'Valore'" [valueInput]="element.importoParcella"></div>
